import React from 'react';

const ContentEditableContext = React.createContext<boolean>(false);

export default ContentEditableContext;
